import { lazy } from 'react';

import { retry } from 'src/utils/routing';

export default {
    name: 'not_found_link',
    path: '/not-found-link',
    component: () => lazy(() => retry(() => import('./index')))
};
